import { Store } from "redux";
import { RootState, OrganizationsState } from "./types";
import { defined } from "common/Support";
import { ConditionVariable } from "common/condition-variable";

let store: Store<RootState> | undefined;

// FIXME: That we have to keep a global copy of the store in here is technical debt.
// We only do this because of a reference cycle keeping loadedOrganizations in store.ts.
export function setGlobalStoreForLoadedState(globalStore: Store<RootState>) {
    store = globalStore;
}

// FIXME: We could get rid of this if we used the ICCC.
export async function loadedOrganizations(): Promise<OrganizationsState> {
    // Usage of this somewhat breaks expectations of Redux.
    // Oh well.
    const currentStore = defined(store);

    const immediateState = currentStore.getState();
    if (immediateState.organizationsLoaded) {
        return immediateState.organizations;
    }

    const condition = new ConditionVariable();
    let organizations: OrganizationsState = [];

    const unsubscribe = currentStore.subscribe(() => {
        const currentState = currentStore.getState();
        if (currentState.organizationsLoaded) {
            organizations = currentState.organizations;
            unsubscribe();
            condition.notifyAll();
        }
    });

    await condition.wait();
    return organizations;
}
